import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/images/expired.png'


const _hoisted_1 = { class: "klicklpay-link" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "img-box" }, null, -1)
const _hoisted_4 = { class: "lang font-bold" }
const _hoisted_5 = {
  key: 0,
  class: "layout font-bold"
}
const _hoisted_6 = {
  key: 0,
  class: "logo"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  src: "/images/sunpay.png",
  alt: "logo"
}
const _hoisted_9 = {
  key: 1,
  src: "/images/logo.png",
  alt: "logo"
}
const _hoisted_10 = { class: "label" }
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "label" }
const _hoisted_13 = { class: "name" }
const _hoisted_14 = { class: "value" }
const _hoisted_15 = { class: "label" }
const _hoisted_16 = { class: "value number" }
const _hoisted_17 = { class: "forms" }
const _hoisted_18 = { class: "item" }
const _hoisted_19 = { class: "item" }
const _hoisted_20 = { class: "item full" }
const _hoisted_21 = {
  class: "tc",
  href: "https://www.klicklpay.com/help/detail",
  target: "_blank"
}
const _hoisted_22 = {
  key: 1,
  class: "layout expired"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "icon"
}, null, -1)
const _hoisted_24 = { class: "font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_popover = _resolveComponent("van-popover")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_van_popover, {
        show: _ctx.showPopover,
        "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPopover = $event)),
        actions: _ctx.data.langs,
        theme: "dark",
        onSelect: _ctx.changeLang
      }, {
        reference: _withCtx(() => [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.convertLangName), 1)
        ]),
        _: 1
      }, 8, ["show", "actions", "onSelect"])
    ]),
    (_ctx.info?.status == 'AVAILABLE')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.info)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_ctx.info?.logo_url)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.info?.logo_url,
                      alt: "logo"
                    }, null, 8, _hoisted_7))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (['sunpaysandbox', 'sunpayprod'].includes(_ctx.dev))
                        ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                        : (_openBlock(), _createElementBlock("img", _hoisted_9))
                    ], 64))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t("defray.orderDetail")), 1),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("defray.businessName")), 1),
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.info?.business_name), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("defray.productName")), 1)
              ]),
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.info?.product_name), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("defray.amount")), 1),
              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.info?.amount) + " " + _toDisplayString(_ctx.info?.currency), 1)
            ])
          ]),
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t("defray.information")), 1),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_van_field, {
                placeholder: _ctx.$t('defray.yourName'),
                modelValue: _ctx.forms.out_user_name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.forms.out_user_name = $event)),
                required: "",
                maxlength: "30",
                type: "text"
              }, null, 8, ["placeholder", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_van_field, {
                placeholder: _ctx.$t('defray.phoneNumber'),
                modelValue: _ctx.forms.phone_number,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.forms.phone_number = $event)),
                required: "",
                maxlength: "30",
                type: "text"
              }, null, 8, ["placeholder", "modelValue"])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["item", { error: _ctx.emailError }])
            }, [
              _createVNode(_component_van_field, {
                placeholder: _ctx.$t('defray.email'),
                required: "",
                modelValue: _ctx.forms.email,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.forms.email = $event)),
                maxlength: "30",
                type: "text",
                onBlur: _ctx.validatorEmail
              }, null, 8, ["placeholder", "modelValue", "onBlur"])
            ], 2),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_van_field, {
                placeholder: _ctx.$t('defray.remarks'),
                modelValue: _ctx.forms.remark,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.forms.remark = $event)),
                rows: "4",
                type: "textarea"
              }, null, 8, ["placeholder", "modelValue"])
            ])
          ]),
          _createVNode(_component_van_button, {
            class: "button",
            round: "",
            block: "",
            disabled: _ctx.isDisableConfirm,
            "native-type": "submit",
            onClick: _ctx.confirm
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("confirm")), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createElementVNode("a", _hoisted_21, _toDisplayString(_ctx.$t("tc")), 1)
        ]))
      : _createCommentVNode("", true),
    (['USED', 'EXPIRED'].includes(_ctx.info?.status))
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("h3", _hoisted_24, _toDisplayString(_ctx.$t("defray.expired")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("defray.expiredTip")), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}